import React, { FC, useRef, useEffect, useState } from 'react';
import _ from 'lodash';
import MiddleLayout from 'src/layout/MiddleLayout';
import './style.scss';

interface Props {}
const Error: FC<Props> = () => {
  const middleContent = () => {
    return (
      <div className="_noauth_content_layout">
        <div className="_content_layout">
          <div className="_content">
            <div className="_icon">
              <i className="ri-alert-line" />
            </div>
            {/* <div className="img_box">
              <img src="/temp/image/noauth.png" />
            </div> */}

            <div className="_label">페이지 권한이 없습니다.</div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="_container">
      <MiddleLayout middle={middleContent()} />
    </div>
  );
};

export default Error;
